import { Component, HostListener, EventEmitter, Input, Output } from '@angular/core';
import { FichaLiquidacionService } from 'src/app/services/liquidacion/ficha-liquidacion.service';
import { LiquidacionService } from 'src/app/services/liquidacion/liquidacion.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { etiquetaCorte, etiquetaCortes } from 'src/app/utils/liquidacion-cortes';

/** SEG-01: la pastilla del paso del pago de un comercio aprobado (en lote, en el banco, no procesado, reintento, pagado). */
const CLASE_PAGO: Record<string, string> = {
  APROBADO: 'kb-badge !border-transparent !bg-foreground !text-background', EN_LOTE: 'kb-badge kb-badge-neutro', EN_BANCO: 'kb-badge kb-badge-neutro',
  NO_PROCESADO: 'kb-badge kb-badge-alerta', RETENIDO: 'kb-badge kb-badge-alerta', REINTENTO: 'kb-badge kb-badge-neutro !border-dashed', PAGADO: 'kb-badge kb-badge-exito' };
export const clasePago = (p: any): string => (p ? CLASE_PAGO[p.paso] || 'kb-badge kb-badge-neutro' : 'kb-badge kb-badge-neutro');
/** El ícono de cada paso del pago, como las insignias de Juan (estado con su ícono, no solo color). */
const ICONO_PAGO: Record<string, string> = {
  APROBADO: 'fa-check-double', EN_LOTE: 'fa-layer-group', EN_BANCO: 'fa-university', NO_PROCESADO: 'fa-times',
  RETENIDO: 'fa-pause', REINTENTO: 'fa-redo', PAGADO: 'fa-check' };
export const iconoPago = (p: any): string => (p ? ICONO_PAGO[p.paso] || '' : '');
export const iconoAvance = (a: any): string => (a?.tono === 'exito' ? 'fa-check' : a?.tono === 'alerta' ? 'fa-exclamation' : 'fa-hourglass-half');
/** FTA-02: la pastilla del avance del pago de una tanda. */
export const claseAvance = (a: any): string => (a?.tono === 'exito' ? 'kb-badge kb-badge-exito' : a?.tono === 'alerta' ? 'kb-badge kb-badge-alerta' : 'kb-badge kb-badge-neutro');

/**
 * FICHA RÁPIDA DE LA TANDA (Mario, 14-oct; FTA-01: «en cierre, abajo en tandas… que si se le hace click lleve a la
 * tanda»). Panel lateral como el de la liquidación: comercios con su neto y el paso de su pago, aprobación (banda,
 * quién preparó y firmó) y los lotes de la tanda con su estado y referencias. La lectura la hace la pantalla del día.
 */
@Component({
  selector: 'app-ficha-tanda',
  templateUrl: './ficha-tanda.component.html',
})
export class FichaTandaComponent {
  /** Escape cierra la ficha aunque el foco no esté dentro del panel (en MT no cerraba, 14-oct). */
  @HostListener('document:keydown.escape') alEscape(): void { this.cerrar.emit(); }
  @Input() ficha: any = null;
  @Input() cargando = false;
  @Input() error = '';
  @Input() dia = '';
  @Output() cerrar = new EventEmitter<void>();
  @Output() verLote = new EventEmitter<string>();
  readonly clasePago = clasePago;
  readonly claseAvance = claseAvance;
  readonly iconoPago = iconoPago;
  readonly iconoAvance = iconoAvance;
  readonly etiquetaCorte = etiquetaCorte;
  /** 13.4: el corte (o los cortes) que trae la tanda: el que manda el núcleo o el de cada comercio. */
  get cortesDeLaTanda(): string { return etiquetaCortes(this.ficha?.cortes || (this.ficha?.comercios || []).map((c: any) => c.corte)); }
  readonly ROL: any = { TES: 'Tesorero', GER: 'Gerente de finanzas', DIR: 'Director' };
  constructor(public fichaLiq: FichaLiquidacionService, private liq: LiquidacionService, private _auth: AuthService) { }
  // FIR-02: el aviso a quien le toca firmar, y reenviarlo.
  get esperaFirma(): boolean { return ['POR_APROBAR', 'FIRMA_1_DE_2'].includes(this.ficha?.state); }
  get puedeReenviar(): boolean { return this.esperaFirma && this._auth.hasPermission('liquidacion.preparar'); }
  reenviando = false;
  resultado = '';
  reenviar = async (): Promise<void> => {
    this.reenviando = true; this.resultado = '';
    try {
      const r = await this.liq.avisarFirmantes(this.dia, this.ficha.n);
      this.resultado = r?.enviado ? `Enviado a ${(r.para || []).join(', ')}` : (r?.error || r?.motivo || 'No se envió');
    } catch (e: any) { this.resultado = e?.error?.msg || 'No se pudo reenviar.'; } finally { this.reenviando = false; }
  };
  hora = (en: any): string => (en ? new Date(new Date(en).getTime() - 4 * 3600e3).toISOString().slice(11, 16) : '—');
  fecha = (iso: string): string => (iso ? iso.split('-').reverse().join('/') : '');
}
